import { Card, CardBody, Container, Row } from "reactstrap";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../../views/common/notification-message/notification";

import DeleteUser from "./../deleteUser";
import EmptyData from "../../../../globals/EmptyData";
import Loading from "./../../loader/loader";
import NkHeader from "./../../../common/nkheader";
import NkTable from "./../../users/nktable";
import React from "react";
import ReferrerCodeContent from "./referrerCodeContent";
import { getDeleteList } from "../manageuserVerification/utils";
import { useHistory } from "react-router-dom";

const ReferrerCodeheader = (
  {
    searchBy,
    setSearchByValue,
    searchFilter,
    setSearchBy,
    // searchByValuePlaceholder,
    searchByValue,
    setDeleteUserShow,
    searchResult,
    deleteLoader,
    onDelete,
    filterValues,
    ReferrerCodeList,
    dataLoading,
    buttonRef,
    filterForm,
    onExcelClciked,
    ReferrerCodeListExcel,
    columns,
    columnsCsv,
    pagination,
    setFilterForm,
    setSizeShow,
    deleteuserShow,
    beneficiaryid,
    handleChange,
    options,
    selectedOption,
    statusFilter,
    setModalShow,
    filtersSelected,
    noOfFiltersSelected,
    resetFilter,
    selectedRow,
    rowOnClick,
    rowId,
  },
  props
) => {
  const history = useHistory();

  return (
    <>
      <Container fluid>
        <NkHeader title="Referrer Codes" />
        <ReferrerCodeContent
          // noData={noData}
          searchBy={searchBy}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          // searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          setModalShow={setModalShow}
          filtersSelected={filtersSelected}
          noOfFiltersSelected={noOfFiltersSelected}
          resetFilter={resetFilter}
          searchFilter={searchFilter}
        />

        <>
          <Row>
            <div
              className="col"
              style={{ paddingRight: "1px", paddingLeft: "1px" }}
            >
              <Card style={{ padding: "1.25rem 1.5rem" }}>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      rowOnClick={rowOnClick}
                      dataexcal
                      filename={"ReferrerCode"}
                      data={ReferrerCodeList}
                      buttonRef={buttonRef}
                      clientSide={false}
                      type="ReferrerCode"
                      filterdata={filterForm}
                      onExcelClciked={() => onExcelClciked(filterForm)}
                      dataEXCEL={ReferrerCodeListExcel}
                      columns={columns}
                      columnsCsv={columnsCsv}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      </Container>

      <DeleteUser
        show={deleteuserShow}
        onHide={() => setDeleteUserShow(false)}
        onDelete={onDelete}
        deleteLoader={deleteLoader}
        statusFilter={statusFilter}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
      />
    </>
  );
};

export default ReferrerCodeheader;
